import React from 'react';

export const WarningCompleteEligibilityForm = () => {
  return (
    <div>
      <p className="mt0">
        <b>End of sponsored care approaching for this patient. </b>
      </p>
      <p>
        Please document next steps for this student&apos;s care in the &apos;Plan&apos; section of
        this note, or in a separate Free-Form Note.
      </p>
    </div>
  );
};

export const WarningOneSessionLeft = () => (
  <div>
    <p className="mt0">
      <b>1 sponsored session remaining &mdash; no next steps selected.</b>
    </p>
    <p>
      Please do not book next appointment until next steps have been selected for this patient. If
      you have any questions, please reach out to Mantra Care Navigation.
    </p>
  </div>
);
